import React from 'react';

const Inventory = () => {
    return (
        <div className='fs-3 d-flex justify-content-center align-items-center' style={{height: "100vh"}}>
            <h2>This is Inventory Testing Page</h2>
        </div>
    );
};

export default Inventory;